import React from 'react'

import styles from './styles.module.css'

import useCheckBreakpoint from 'lib/checkBreakpoint'

export type AdBannerProps = {
  bannerUrl: {
    pc: string
    sp: string
  }
  bannerImage: {
    pc: string
    sp: string
  }
}

export const AdBanner: React.FC<AdBannerProps> = ({ bannerUrl, bannerImage }) => {
  const { isMobile } = useCheckBreakpoint()
  const href = isMobile ? bannerUrl.sp : bannerUrl.pc

  return (
    <a className={styles.container} href={href} target="_blank" rel="noopener noreferrer">
      <picture className={styles.picture}>
        <source media="(max-width: 575px)" srcSet={bannerImage.sp} />
        <img className={styles.bannerImage} src={bannerImage.pc} alt="ads banner" />
      </picture>
    </a>
  )
}
